import { Reveal } from "../lib/motion";

const METRICS = [
  { value: "9+", label: "Years in Practice" },
  { value: "50+", label: "Clients Served" },
  { value: "$50M+", label: "Capital Raised / Supported" },
  { value: "~30", label: "Years of Finance Leadership Experience" },
];

export const TrustBar = () => (
  <section data-testid="trust-bar" className="relative bg-navy dark-grid-bg">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 grid grid-cols-2 lg:grid-cols-4 gap-y-10">
      {METRICS.map((m, i) => (
        <Reveal key={m.label} delay={i * 0.08} className={`${i > 0 ? "lg:border-l lg:border-white/10 lg:pl-10" : ""}`}>
          <p data-testid={`metric-value-${i}`} className="font-display text-5xl md:text-6xl font-extrabold tracking-tight text-white">
            {m.value.replace("+", "")}
            {m.value.includes("+") && <span className="text-brand">+</span>}
          </p>
          <p className="mt-2 text-xs font-semibold uppercase tracking-[0.22em] text-white/55">{m.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
